import { createModuleDescriptor } from '../../redux/module-descriptor';
import entities from './entities';

export default createModuleDescriptor('pim', {
  entities: Object.values(entities),
});
